import { Reveal, Overline } from "./Reveal";

export const Development = () => (
  <section data-testid="development-section" className="py-28 sm:py-40 bg-white">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
      <div className="border border-[#D4B3AD]/50 bg-[#FAF2F0] p-10 sm:p-20 relative overflow-hidden">
        <span aria-hidden className="absolute -top-8 -right-4 font-display font-bold uppercase text-[9rem] leading-none text-outline select-none pointer-events-none hidden sm:block">
          2026
        </span>
        <Reveal><Overline>Transparence</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display uppercase tracking-tight leading-[1.02] text-3xl sm:text-5xl mt-6">
            En cours de développement.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 max-w-2xl space-y-6 text-[#6E6A66] text-base sm:text-lg leading-relaxed">
            <p>SOLAMOVE est actuellement en phase de développement, de prototypage et de validation.</p>
            <p>
              Nous travaillons notamment sur le poids, la flexibilité et le confort
              afin d'aboutir à la version finale du produit.
            </p>
            <p>
              Les caractéristiques, visuels et spécifications présentés avant le lancement peuvent donc évoluer.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-12 font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#736F6E]">
            Prototype — Tests — Validation — Lancement
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
